import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/travogue/travogue/src/app/destinations/[slug]/DestinationPageClient.jsx");
